import 'waypoints/lib/noframework.waypoints.js';

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.headerElement = document.querySelector('.site-header');
    this.searchInputWrapper = this.querySelector('[data-search-input-wrapper]');
    this.panelMenu = document.querySelector('panel-menu');

    this.onLoadCustomEventListeners();
    this.initializeWaypoint();
    this.addScrollEventListener();
    this.searchInput();
  }

  initializeWaypoint() {
    document.addEventListener('DOMContentLoaded', () => {
      const headerElement = this.headerElement;

      new globalThis.Waypoint({
        element: this.headerElement,
        handler: function (direction) {
          if (direction === 'down') {
            headerElement.classList.add('out-of-view');
          } else {
            headerElement.classList.remove('out-of-view');
          }
        },
        offset: -120
      });
    });
  }

  addScrollEventListener() {
    let scrollPos = 0;

    window.addEventListener('scroll', () => {
      if (document.body.getBoundingClientRect().top > scrollPos) {
        this.showNavigationBar();
      } else {
        // Don't hide header if search is active or panel menu is active
        if (
          Object.hasOwn(this.searchInputWrapper.dataset, 'active') ||
          this.panelMenu?.hasAttribute('data-active-level')
        )
          return;
        this.hideNavigationBar();
      }
      scrollPos = document.body.getBoundingClientRect().top;
    });

    this.searchInput();
    this.mobileNavToggle();
  }

  /**
   * Hide the navigation bar
   * @returns {void}
   */
  hideNavigationBar() {
    globalThis.setTimeout(() => {
      this.headerElement.classList.add('not-visible');
      this.headerElement.classList.remove('visible');
    }, 300);
  }

  /**
   * Show the navigation bar
   * @returns {void}
   */
  showNavigationBar() {
    globalThis.setTimeout(() => {
      this.headerElement.classList.add('visible');
      this.headerElement.classList.remove('not-visible');
    }, 300);
  }

  /**
   * Expand the search input when the search icon is clicked
   * @returns {void}
   */
  searchInput() {
    // Clicking the search icon in the header, gives focus the the search input
    const searchIcon = this.querySelectorAll('[data-header-search-icon]');
    const searchInput = document.querySelector(
      '[data-predictive-search-input]'
    );
    const closePredictiveSearch = document.querySelector(
      '[data-close-predictive-search]'
    );

    for (const icon of searchIcon) {
      icon.addEventListener('click', () => {
        this.searchInputWrapper.dataset.active = '';
        this.showNavigationBar();
        searchInput.scrollIntoView({ behavior: 'smooth' });
        searchInput.focus({ preventScroll: true });
        this.panelMenu?.closeMenu();
      });
    }

    closePredictiveSearch.addEventListener('click', () => {
      delete this.searchInputWrapper.dataset.active;
      searchInput.value = '';
      this.querySelector('predictive-search').closeSearch();
    });
  }

  /**
   * Toggles the mobile menu
   * @returns {void}
   */
  mobileNavToggle() {
    const button = this.querySelector('[data-mobile-nav-button]');
    button.addEventListener('click', () => {
      this.scrollSoHeaderBarIsTop();
      this.panelMenu?.toggleMobileMenu();

      const predictiveSearch = document.querySelector('predictive-search');
      predictiveSearch?.closePredictiveSearch();
    });
  }

  /**
   * Listen to pxl:addToCartSuccess event to show the navigation bar
   * @returns {void}
   */
  onLoadCustomEventListeners() {
    // Show the navigation bar when an item is added to the cart
    document.addEventListener('pxl:addToCartSuccess', () =>
      this.showNavigationBar()
    );

    // Prevent pointer events on the header when the flyout cart is open
    document.addEventListener('pxl:flyoutCart:toggleState', event => {
      this.toggleNoPointerEvents(event);
    });
  }

  /**
   * If it isn't already, scrolls the page so the header bar is at the top of the page
   * @returns {void}
   */
  scrollSoHeaderBarIsTop() {
    const headerElement = document.querySelector('.site-header'); // this needs to the the outer section. We can't put a data-attribute
    const headerOffset = headerElement.offsetTop;
    const scrollPosition = window.scrollY;

    if (headerOffset > scrollPosition) {
      window.scrollTo({
        top: headerOffset,
        behavior: 'smooth'
      });
    }
  }

  /**
   * Adds the no-pointer-events class to the header
   */
  toggleNoPointerEvents(event) {
    const header = document.querySelector('sticky-header');
    if (event.detail.open) {
      header.setAttribute('no-pointer-events', '');
    } else {
      header.removeAttribute('no-pointer-events', '');
    }
  }
}

customElements.get('sticky-header') ||
  customElements.define('sticky-header', StickyHeader);
